import React, { Fragment, useState } from "react";
import Spinner from "../layout/Spinner";
import { useEffect } from "react";
import WarrantyInfo from "../report/WarrantyInfo";
import ServiceInfo from "../report/ServiceInfo";
import { getWarrantyInfo, getWarrantyDetails } from "../../action/warranty";
import Popup from "../layout/Popup";
import { connect } from "react-redux";
import isObjectEmpty from "../../utils/checkEmptyObject";
import customConfig from "../../config";
import { Box, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import AppButton from "../Common/Button/Button";
import { setAlert } from "../../action/alert";

const ReportHome = ({
  report,
  user,
  address,
  addressLine1,
  city,
  pincode,
  loading,
  getWarrantyInfo,
  getWarrantyDetails,
  setAlert,
  warrantyData: {
    warrantyToken,
    applianceData,
    applianceError,
    warrantyDetails,
  },
}) => {
  const [showWarrantyInfo, setShowWarrantyInfo] = useState(false);
  const [showServiceInfo, setShowServiceInfo] = useState(false);
  const [showWarrantyService, setShowWarrantyService] = useState(true);

  useEffect(() => {
    if (user) {
      getWarrantyInfo(user.mobile);
    }
  }, []);

  useEffect(() => {
    if (applianceData && !applianceError) {
      applianceData.customer_products.map((product, i) => {
        getWarrantyDetails(warrantyToken, product.id);
      });
    }
    return;
  }, [applianceData]);

  useEffect(() => {
    if (report.spaces && report.spaces.length > 0) {
      report.spaces.forEach((space) => {
        if (space.devices.length > 0) {
          setShowWarrantyService(false);
        }
      });
    }
  }, [report.spaces]);

  const handleWarrantyPopup = (viewService = false) => {
    if (
      !(
        applianceData.customer_products &&
        applianceData.customer_products.length > 0
      )
    ) {
      const alertMsg = viewService
        ? customConfig.noServiceDataMsg
        : customConfig.noWarrantyDataMsg;
      setAlert(alertMsg, "info");
      return;
    }
    if (viewService) {
      setShowServiceInfo(true);
    } else {
      setShowWarrantyInfo(true);
    }
  };

  const handleServiceInfoPopupClose = () => {
    setShowServiceInfo(false);
  };

  const handleWarrantyInfoPopupClose = () => {
    setShowWarrantyInfo(false);
  };

  if (!report) {
    return <h4>Data not Found</h4>;
  }

  return loading || report === null ? (
    <Spinner />
  ) : (
    <div className="user-information">
      <Box sx={{ width: "100%" }}>
        <Grid2
          container
          spacing={{ xs: 1.5, sm: 2 }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          sx={{ mb: 1 }}
        >
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Box sx={{ pt: 0.5 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 18 }}>
                Home Details
              </Typography>
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            {showWarrantyService && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-start", sm: "flex-end" },
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <AppButton
                  variant="ghost"
                  size="medium"
                  onClick={() => handleWarrantyPopup()}
                >
                  View warranty info
                </AppButton>
                {showWarrantyInfo && (
                  <Popup
                    visible={showWarrantyInfo}
                    notifyPopupClose={handleWarrantyInfoPopupClose}
                    wide={true}
                  >
                    {" "}
                    <WarrantyInfo
                      products={
                        applianceData && applianceData.customer_products
                          ? applianceData.customer_products
                          : null
                      }
                      showProductInfo={true}
                    />
                  </Popup>
                )}

                <AppButton
                  variant="ghost"
                  size="medium"
                  onClick={() => handleWarrantyPopup(true)}
                >
                  View service requests
                </AppButton>
                {showServiceInfo && (
                  <Popup
                    visible={showServiceInfo}
                    notifyPopupClose={handleServiceInfoPopupClose}
                    wide={true}
                  >
                    {" "}
                    <ServiceInfo
                      products={
                        applianceData && applianceData.customer_products
                          ? applianceData.customer_products
                          : null
                      }
                      showProductInfo={true}
                    />
                  </Popup>
                )}
              </Box>
            )}
          </Grid2>
        </Grid2>

        <Grid2 container spacing={{ xs: 1.5, sm: 2 }}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Box sx={{ mb: { xs: 0.5, sm: 1.5 } }}>
              <Typography
                component="label"
                variant="body2"
                sx={{ color: "#666666", mb: 0.5, display: "block" }}
              >
                Home Address
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: 14, fontWeight: 500, color: "#000", lineHeight: 1.4 }}
              >
                {report && report.address && report.address.addressLine1},{" "}
                {report && report.address && report.address.addressLine2},{" "}
                {report && report.address && report.address.city},{" "}
                {report && report.address && report.address.pincode}
              </Typography>
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Box sx={{ mb: { xs: 0.5, sm: 1.5 } }}>
              <Typography
                component="label"
                variant="body2"
                sx={{ color: "#666666", mb: 0.5, display: "block" }}
              >
                Home Name
              </Typography>
              <Typography
                variant="body1"
                sx={{ fontSize: 14, fontWeight: 500, color: "#000", lineHeight: 1.4 }}
              >
                {report && report.homeName}
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  warrantyData: state.warranty,
});
export default connect(mapStateToProps, (dispatch) => ({
  getWarrantyInfo: (...args) => dispatch(getWarrantyInfo(...args)),
  getWarrantyDetails: (...args) => dispatch(getWarrantyDetails(...args)),
  setAlert: (msg, type) => dispatch(setAlert(msg, type)),
}))(ReportHome);
